export default __webpack_public_path__ + "8f39c9e90ba340f0fe05c54269f6333e.png";